export default __webpack_public_path__ + "static/media/g00gle-ads-logo.79971317.svg";